import type { User } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { HookedSubmitButton } from '../../components/forms/V3HookedSubmitButton';
import { createModal } from '../../components/generic/Modal';
import { useResendInviteEmailMutation } from '../../graphql/hooks/useResendInviteEmailMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  user: User;
}

export const UserReinviteModal = createModal<Props>((props) => {
  const { user, modal } = props;
  const { visible, hide, remove } = modal;
  const { organization, successToast, errorToast } = useAppContext();

  const methods = useForm({});
  const resendInviteMutation = useResendInviteEmailMutation();

  const onSubmit = async () => {
    await resendInviteMutation
      .mutateAsync({
        organizationId: organization.id,
        userId: user.id,
      })
      .then(() => {
        successToast('Invitation email sent successfully');
        hide();
      })
      .catch((error) => {
        errorToast(`Error sending invitation: ${error.message}`);
      });
  };

  return (
    <ChakraV3.Dialog.Root open={visible} onOpenChange={hide} onExitComplete={remove}>
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ChakraV3.Dialog.Content>
              <ChakraV3.DialogTitleSubtitle
                title='Reinvite'
                subtitle={`Send invitation email to ${user.name}`}
              />
              <ChakraV3.Dialog.Body>
                Are you sure you want to resend the invitation email to {user.name} ({user.email})?
              </ChakraV3.Dialog.Body>
              <ChakraV3.Dialog.Footer>
                <ChakraV3.HStack>
                  <ChakraV3.Button onClick={hide} size='sm' variant='subtle'>
                    Close
                  </ChakraV3.Button>
                  <HookedSubmitButton disabled={false} loadingText='Sending invitation...'>
                    Reinvite
                  </HookedSubmitButton>
                </ChakraV3.HStack>
              </ChakraV3.Dialog.Footer>
            </ChakraV3.Dialog.Content>
          </form>
        </FormProvider>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});
